import type { FieldType } from "@/schemas/digital-files";

function isValidUrlValue(value: unknown): boolean {
  if (value instanceof File) return true;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object" && value !== null) {
    const fileValue = value as { id?: string; url?: string };
    return !!(fileValue.id && fileValue.url);
  }
  return false;
}

export function validateRequired(
  field: FieldType,
  value: unknown,
): string | undefined {
  if (value === undefined || value === null || value === "") {
    return `${field.name} es obligatorio`;
  }
  if (field.field_type === "URL" && !isValidUrlValue(value)) {
    return `${field.name} es obligatorio`;
  }
  const isDateRange =
    (field.field_type === "DATE" || field.field_type === "DATETIME") &&
    field.configuration?.type === "date_range";
  if (isDateRange) {
    const rangeValue = value as { start?: string; end?: string } | undefined;
    if (!rangeValue?.start || !rangeValue?.end) {
      return `Debe seleccionar fecha de inicio y fin`;
    }
  }
  return undefined;
}

function validateEmailDomains(
  domain: string,
  config: FieldType["configuration"],
): string | undefined {
  const normalize = (domains: string[]) =>
    domains.map((d) => d.toLowerCase().trim().replace(/^@/, ""));

  const allowedDomains = config?.allowedDomains;
  if (Array.isArray(allowedDomains) && allowedDomains.length > 0) {
    const normalized = normalize(allowedDomains);
    const isAllowed = normalized.some(
      (a) => domain === a || domain.endsWith(`.${a}`),
    );
    if (!isAllowed) {
      return `Solo se permiten correos de los dominios: ${normalized.join(", ")}`;
    }
  }

  const blockedDomains = config?.noAllowedDomains;
  if (Array.isArray(blockedDomains) && blockedDomains.length > 0) {
    const normalized = normalize(blockedDomains);
    const isBlocked = normalized.some(
      (b) => domain === b || domain.endsWith(`.${b}`),
    );
    if (isBlocked) {
      return `No se permiten correos de los dominios: ${normalized.join(", ")}`;
    }
  }

  return undefined;
}

export function validateEmail(
  emailStr: string,
  config: FieldType["configuration"],
): string | undefined {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (!emailRegex.test(emailStr)) return "Correo electrónico inválido";
  const domain = emailStr.split("@")[1]?.toLowerCase();
  return domain ? validateEmailDomains(domain, config) : undefined;
}
